import ModalWrapper from "./ModalWrapper";
import { useNavigate } from "react-router-dom";

export default function SmallScreenModal() {
  const navigate = useNavigate();

  return (
    <ModalWrapper>
      <div className="createbot-modal small-modal sm-modal">
        <div className="craetebot-container">
          <div className="success-cont">
            <div className="err-header">
              <ComputerIcon />
            </div>
            <div className="succ-footer">
              <h1>Screen Too Small</h1>
              <div className="err-ft-p">
                <p>
                  Please access it through a device with minimum screen
                  resolution of 1280 x 960 or higher
                </p>
              </div>
              <button className="w-mc p-[10px]">
                <a href="/dashboard">Go to Dashboard</a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
}

function ComputerIcon() {
  return (
    <svg
      width="132"
      height="132"
      viewBox="0 0 132 132"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="66" cy="66" r="66" fill="white" fillOpacity="0.2" />
      <circle
        cx="66.0002"
        cy="66.0002"
        r="57.8947"
        fill="white"
        fillOpacity="0.36"
      />
      <rect
        x="19.002"
        y="19"
        width="94.9474"
        height="94.9474"
        rx="47.4737"
        fill="white"
      />
      <path
        d="M35 52.25C35 50.5924 35.6532 49.0027 36.8159 47.8306C37.9787 46.6585 39.5557 46 41.2 46H90.8C92.4443 46 94.0213 46.6585 95.1841 47.8306C96.3468 49.0027 97 50.5924 97 52.25V80.375C97 82.0326 96.3468 83.6223 95.1841 84.7944C94.0213 85.9665 92.4443 86.625 90.8 86.625H41.2C39.5557 86.625 37.9787 85.9665 36.8159 84.7944C35.6532 83.6223 35 82.0326 35 80.375V52.25ZM53.104 92.5H80.88Z"
        fill="#FB5F66"
      />
      <path
        d="M53.104 92.5H80.88M35 52.25C35 50.5924 35.6532 49.0027 36.8159 47.8306C37.9787 46.6585 39.5557 46 41.2 46H90.8C92.4443 46 94.0213 46.6585 95.1841 47.8306C96.3468 49.0027 97 50.5924 97 52.25V80.375C97 82.0326 96.3468 83.6223 95.1841 84.7944C94.0213 85.9665 92.4443 86.625 90.8 86.625H41.2C39.5557 86.625 37.9787 85.9665 36.8159 84.7944C35.6532 83.6223 35 82.0326 35 80.375V52.25Z"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M75.2596 72.375L67.1996 58.3125C67.0795 58.1035 66.8722 58 66.6629 58C66.4537 58 66.2444 58.1035 66.1262 58.3125L58.0662 72.375C57.8279 72.793 58.1263 73.3125 58.6029 73.3125H74.7229C75.1995 73.3125 75.4979 72.793 75.2596 72.375ZM66.0429 63.7812C66.0429 63.6953 66.1127 63.625 66.1979 63.625H67.1279C67.2132 63.625 67.2829 63.6953 67.2829 63.7812V67.375C67.2829 67.4609 67.2132 67.5312 67.1279 67.5312H66.1979C66.1127 67.5312 66.0429 67.4609 66.0429 67.375V63.7812ZM66.6629 70.6562C66.4195 70.6512 66.1878 70.5503 66.0175 70.375C65.8471 70.1997 65.7517 69.9641 65.7517 69.7188C65.7517 69.4734 65.8471 69.2378 66.0175 69.0625C66.1878 68.8872 66.4195 68.7863 66.6629 68.7812C66.9063 68.7863 67.138 68.8872 67.3084 69.0625C67.4787 69.2378 67.5741 69.4734 67.5741 69.7188C67.5741 69.9641 67.4787 70.1997 67.3084 70.375C67.138 70.5503 66.9063 70.6512 66.6629 70.6562V70.6562Z"
        fill="white"
      />
    </svg>
  );
}
